// extracted by mini-css-extract-plugin
export default {"modal":"RuleDeleteModal_modal__O1EEk","cancelButton":"RuleDeleteModal_cancelButton__KmmxC","confirmButton":"RuleDeleteModal_confirmButton__gU7Hh"};